<div class="flex w-60 flex-col gap-6">
    <app-watchlist class="h-60" />
    <div
        class="rounded-md border border-[#91AFF4] p-4 shadow-[2px_2px_3px_0px_#0045E670]"
    >
        <span class="font-extrabold uppercase text-[#0045E6]"
            >PLUS GROS VOLUMES</span
        >
        <div class="p-1">
            <a
                *ngFor="let volume of volumes"
                  (click)="reloadPage(volume?.referentiel?.stockName,volume?.referentiel?.isin)"

                class="flex items-center justify-between border-b border-dotted border-[#adadad] py-1 last:border-none"
            >
                <span class="text-sm hover:underline">{{ volume?.referentiel?.ticker }}</span>
                <div class="flex flex-col items-end">
                    <span class="text-xs text-black">{{
                        volume?.volume | number: '.2-2'
                    }}</span>
                    <span
                        class="text-sm"
                        [ngClass]="{
                            'text-[#E70013]': volume?.change < 0,
                            'text-[#7DAF66]': volume?.change >= 0,
                        }"
                    >
                        <mat-icon
                            class="icon-size-3"
                            [ngClass]="{
                                'text-[#E70013]': volume?.change < 0,
                                'text-[#7DAF66]': volume?.change >= 0,
                            }"
                            [svgIcon]="
                                volume?.change >= 0
                                    ? 'heroicons_solid:arrow-small-up'
                                    : 'heroicons_solid:arrow-small-down'
                            "
                        />
                        {{ volume?.change | abs | number: '.2-2' }}%</span
                    >
                </div>
            </a>
        </div>
    </div>

    <div
        class="rounded-md border border-[#91AFF4] p-4 shadow-[2px_2px_3px_0px_#0045E670]"
    >
        <span class="font-extrabold uppercase text-[#49BFA1]">Top HAUSSES</span>
        <div class="p-1">
            <a
                *ngFor="let hausse of hausses"
               (click)="reloadPage(hausse?.referentiel?.stockName, hausse?.referentiel?.isin)"

                class="flex items-center justify-between border-b border-dotted border-[#adadad] py-1 last:border-none"
            >
                <span class="text-sm hover:underline">{{ hausse?.referentiel?.ticker }}</span>
                <div class="flex flex-col items-end">
                    <span class="text-xs text-black">{{
                        hausse?.last | number: '.2-2'
                    }}</span>
                    <span
                        class="text-sm"
                        [ngClass]="{
                            'text-[#E70013]': hausse?.change < 0,
                            'text-[#7DAF66]': hausse?.change >= 0,
                        }"
                    >
                        <mat-icon
                            class="icon-size-3"
                            [ngClass]="{
                                'text-[#E70013]': hausse?.change < 0,
                                'text-[#7DAF66]': hausse?.change >= 0,
                            }"
                            [svgIcon]="
                                hausse?.change >= 0
                                    ? 'heroicons_solid:arrow-small-up'
                                    : 'heroicons_solid:arrow-small-down'
                            "
                        />
                        {{ hausse?.change | abs | number: '.2-2' }}%</span
                    >
                </div>
            </a>
        </div>
    </div>

    <div
        class="rounded-md border border-[#91AFF4] p-4 shadow-[2px_2px_3px_0px_#0045E670]"
    >
        <span class="font-extrabold uppercase text-[#E70013]">Top BAISSES</span>
        <div class="p-1">
            <a
                *ngFor="let baisse of baisses"
                  (click)="reloadPage(baisse?.referentiel?.stockName,baisse?.referentiel?.isin)"

                class="flex items-center justify-between border-b border-dotted border-[#adadad] py-1 last:border-none"
            >
                <span class="text-sm hover:underline">{{ baisse?.referentiel?.ticker }}</span>
                <div class="flex flex-col items-end">
                    <span class="text-xs text-black">{{
                        baisse?.last | number: '.2-2'
                    }}</span>
                    <span
                        class="text-sm"
                        [ngClass]="{
                            'text-[#E70013]': baisse?.change < 0,
                            'text-[#7DAF66]': baisse?.change >= 0,
                        }"
                    >
                        <mat-icon
                            class="icon-size-3"
                            [ngClass]="{
                                'text-[#E70013]': baisse?.change < 0,
                                'text-[#7DAF66]': baisse?.change >= 0,
                            }"
                            [svgIcon]="
                                baisse?.change >= 0
                                    ? 'heroicons_solid:arrow-small-up'
                                    : 'heroicons_solid:arrow-small-down'
                            "
                        />
                        {{ baisse?.change | abs | number: '.2-2' }}%</span
                    >
                </div>
            </a>
        </div>
    </div>
</div>
